<template>
  <div :class="[show ? 'block' : 'hidden', 'absolute top-0 left-0 h-full w-full']">
    <VOverlay
      :model-value="show"
      :contained
      :class="[
        sticky ? 'sticky h-screen' : 'absolute h-full',
        'inset-0 flex justify-center items-center',
        '!z-40'
      ]"
    >
      <VProgressCircular :indeterminate />
    </VOverlay>
  </div>
</template>

<script setup lang="ts">
interface Props {
  indeterminate?: boolean
  show: boolean
  contained: boolean
  sticky?: boolean
}

const { indeterminate = true, show, contained } = defineProps<Props>()
</script>

<style scoped></style>
